var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$t(_vm.flagSelected) === _vm.$t("Updated Products")
        ? _c("h2", { staticClass: "page-title-bar" }, [
            _c("i", { staticClass: "ico ico-product" }),
            _vm._v(_vm._s(_vm.$t("Update Records")) + " ")
          ])
        : _vm._e(),
      _vm.$t(_vm.flagSelected) === _vm.$t("Scheduled Products")
        ? _c("h2", { staticClass: "page-title-bar" }, [
            _c("i", { staticClass: "ico ico-product" }),
            _vm._v(_vm._s(_vm.$t("Scheduled Products")) + " ")
          ])
        : _vm._e(),
      _c(
        "v-row",
        { staticClass: "pa-0 ma-0" },
        [
          _c(
            "v-col",
            { staticClass: "d-flex align-center pb-0", attrs: { cols: "2" } },
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    "offset-y": "",
                    "close-on-content-click": false,
                    "content-class": "columnMenu"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "manage-btn btn",
                                  attrs: { text: "", small: "" }
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("Manage Columns")) + " "
                              ),
                              _c(
                                "v-icon",
                                {
                                  class: { rotate: _vm.menuOpen },
                                  attrs: { right: "" }
                                },
                                [_vm._v(" mdi-chevron-down ")]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.menuOpen,
                    callback: function($$v) {
                      _vm.menuOpen = $$v
                    },
                    expression: "menuOpen"
                  }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "column-card" },
                    [
                      _c("v-card-title", { staticClass: "column-header" }, [
                        _vm._v(" " + _vm._s(_vm.$t("Select Columns")) + " ")
                      ]),
                      _c("v-divider"),
                      _c(
                        "v-list",
                        { staticClass: "select-all", attrs: { dense: "" } },
                        [
                          _c(
                            "v-list-item",
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  "input-value": _vm.isAllSelected,
                                  "hide-details": ""
                                },
                                on: { change: _vm.toggleSelectAll }
                              }),
                              _c("v-list-item-title", [
                                _vm._v(" " + _vm._s(_vm.$t("Select All")) + " ")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-card-text",
                        { staticClass: "column-list" },
                        [
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l(_vm.currentManageHeaders.slice(2), function(
                              header
                            ) {
                              return _c(
                                "v-list-item",
                                { key: header.value },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      value: header.text,
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.visibleColumns,
                                      callback: function($$v) {
                                        _vm.visibleColumns = $$v
                                      },
                                      expression: "visibleColumns"
                                    }
                                  }),
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "column-text" },
                                    [_vm._v(" " + _vm._s(header.text) + " ")]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-card-actions",
                        { staticClass: "column-footer" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticStyle: {
                                background: "#c57171",
                                color: "#ffffff !important",
                                width: "80px"
                              },
                              attrs: { color: "error", text: "", small: "" },
                              on: {
                                click: function($event) {
                                  _vm.menuOpen = false
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticStyle: { width: "80px" },
                              attrs: { color: "primary", small: "" },
                              on: {
                                click: function($event) {
                                  _vm.menuOpen = false
                                  _vm.saveVisibleColumns()
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex align-center justify-center pa-0 mt-6",
              attrs: { cols: "1" }
            },
            [_c("v-divider", { attrs: { vertical: "" } })],
            1
          ),
          _c(
            "v-col",
            { staticClass: "d-flex flex-column", attrs: { cols: "9" } },
            [
              _c(
                "section",
                { staticClass: "searchArea d-flex flex-wrap" },
                [
                  _c("v-select", {
                    staticClass: "form-input",
                    staticStyle: { width: "25%" },
                    attrs: {
                      items: [
                        _vm.$t("Updated Products"),
                        _vm.$t("Scheduled Products")
                      ],
                      label: _vm.$t("Product Update Type"),
                      outlined: "",
                      dense: "",
                      "hide-details": ""
                    },
                    on: { change: _vm.changeType },
                    model: {
                      value: _vm.flagSelected,
                      callback: function($$v) {
                        _vm.flagSelected = $$v
                      },
                      expression: "flagSelected"
                    }
                  }),
                  _c("v-text-field", {
                    staticClass: "form-input ml-3",
                    staticStyle: { width: "25%" },
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      label: _vm.$t("File Name"),
                      placeholder: _vm.$t("Input file name"),
                      clearable: ""
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.searchRecords($event)
                      }
                    },
                    model: {
                      value: _vm.searchBy.fileName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchBy, "fileName", $$v)
                      },
                      expression: "searchBy.fileName"
                    }
                  }),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn type-search ml-3",
                      attrs: { text: "" },
                      on: { click: _vm.searchRecords }
                    },
                    [_vm._v(_vm._s(_vm.$t("Search")))]
                  )
                ],
                1
              ),
              _c(
                "section",
                { staticClass: "searchArea d-flex flex-wrap mt-2" },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        "offset-y": "",
                        "min-width": "290px"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "form-input",
                                      staticStyle: { width: "25%" },
                                      attrs: {
                                        value: _vm.searchBy.startDate,
                                        label: "" + _vm.$t("Period"),
                                        placeholder:
                                          "" + _vm.$t("Select start date"),
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "",
                                        readonly: "",
                                        clearable: ""
                                      },
                                      on: {
                                        "click:clear": function($event) {
                                          return _vm.clearDate(
                                            _vm.searchBy,
                                            "startDate"
                                          )
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "append",
                                            fn: function() {
                                              return [
                                                _c("img", {
                                                  attrs: {
                                                    width: "16",
                                                    height: "16",
                                                    src: require("@/assets/img/ico-calendar.png")
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    "v-text-field",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.showStartDatePicker,
                        callback: function($$v) {
                          _vm.showStartDatePicker = $$v
                        },
                        expression: "showStartDatePicker"
                      }
                    },
                    [
                      _c("v-date-picker", {
                        attrs: {
                          locale:
                            _vm.languageCodes[
                              _vm.$store.getters[
                                "dataStore/GET_CURRENT_LANGUAGE"
                              ]
                            ],
                          "no-title": ""
                        },
                        on: {
                          change: _vm.checkStartDate,
                          input: function($event) {
                            _vm.showStartDatePicker = false
                          }
                        },
                        model: {
                          value: _vm.searchBy.startDate,
                          callback: function($$v) {
                            _vm.$set(_vm.searchBy, "startDate", $$v)
                          },
                          expression: "searchBy.startDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c("span", { staticClass: "ml-1 mr-1" }, [_vm._v("~")]),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        "offset-y": "",
                        "min-width": "290px"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "form-input",
                                      staticStyle: { width: "25%" },
                                      attrs: {
                                        value: _vm.searchBy.endDate,
                                        placeholder:
                                          "" + _vm.$t("Select end date"),
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "",
                                        solo: "",
                                        readonly: "",
                                        clearable: ""
                                      },
                                      on: {
                                        "click:clear": function($event) {
                                          return _vm.clearDate(
                                            _vm.searchBy,
                                            "endDate"
                                          )
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "append",
                                            fn: function() {
                                              return [
                                                _c("img", {
                                                  attrs: {
                                                    width: "16",
                                                    height: "16",
                                                    src: require("@/assets/img/ico-calendar.png")
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    "v-text-field",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.showEndDatePicker,
                        callback: function($$v) {
                          _vm.showEndDatePicker = $$v
                        },
                        expression: "showEndDatePicker"
                      }
                    },
                    [
                      _c("v-date-picker", {
                        attrs: {
                          locale:
                            _vm.languageCodes[
                              _vm.$store.getters[
                                "dataStore/GET_CURRENT_LANGUAGE"
                              ]
                            ],
                          "no-title": ""
                        },
                        on: {
                          change: _vm.checkEndDate,
                          input: function($event) {
                            _vm.showEndDatePicker = false
                          }
                        },
                        model: {
                          value: _vm.searchBy.endDate,
                          callback: function($$v) {
                            _vm.$set(_vm.searchBy, "endDate", $$v)
                          },
                          expression: "searchBy.endDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn type-search ml-3",
                      attrs: { text: "" },
                      on: { click: _vm.clear }
                    },
                    [_vm._v(_vm._s(_vm.$t("Clear")))]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm.$t(_vm.flagSelected) === _vm.$t("Updated Products")
        ? _c(
            "v-data-table",
            {
              staticClass: "tbl-type01 mt-10",
              attrs: {
                "item-key": "id",
                headers: _vm.filteredRecordHeaders,
                items: _vm.tableItems,
                page: _vm.page,
                "hide-default-footer": true,
                options: _vm.options,
                "server-items-length": _vm.totalRecords
              },
              on: {
                "update:page": function($event) {
                  _vm.page = $event
                },
                "update:options": function($event) {
                  _vm.options = $event
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "item.download",
                    fn: function(props) {
                      return [
                        _c(
                          "v-btn",
                          {
                            staticClass: "mx-2",
                            attrs: {
                              icon: "",
                              disabled: _vm.isDownloadExpired(
                                props.item.completed
                              )
                            },
                            on: {
                              click: function() {
                                return _vm.toDownloadarticles(props.item)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { dark: "" } }, [
                              _vm._v("mdi-download")
                            ])
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                1347146361
              )
            },
            [
              _c("template", { slot: "no-data" }, [
                _c("p", [
                  _vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")
                ])
              ])
            ],
            2
          )
        : _vm._e(),
      _vm.$t(_vm.flagSelected) === _vm.$t("Scheduled Products")
        ? _c(
            "v-data-table",
            {
              staticClass: "tbl-type01 mt-10",
              staticStyle: { cursor: "pointer" },
              attrs: {
                "item-key": "id",
                headers: _vm.filteredSchedulerecordHeaders,
                items: _vm.tableItems,
                page: _vm.page,
                "hide-default-footer": true,
                options: _vm.options,
                "server-items-length": _vm.totalRecords,
                "single-select": true,
                "show-select": ""
              },
              on: {
                "update:page": function($event) {
                  _vm.page = $event
                },
                "update:options": function($event) {
                  _vm.options = $event
                },
                "click:row": _vm.handleRowClick
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "item.download",
                    fn: function(props) {
                      return [
                        _c(
                          "v-btn",
                          {
                            staticClass: "mx-2",
                            attrs: {
                              icon: "",
                              disabled: _vm.isDownloadExpired(
                                props.item.processDate
                              )
                            },
                            on: {
                              click: function() {
                                return _vm.toDownloadarticles(props.item)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { dark: "" } }, [
                              _vm._v("mdi-download")
                            ])
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                1355436779
              ),
              model: {
                value: _vm.selected,
                callback: function($$v) {
                  _vm.selected = $$v
                },
                expression: "selected"
              }
            },
            [
              _c("template", { slot: "no-data" }, [
                _c("p", [
                  _vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")
                ])
              ])
            ],
            2
          )
        : _vm._e(),
      _c("div", { staticClass: "table-options" }, [
        _c(
          "div",
          [
            _vm.$t(_vm.flagSelected) === _vm.$t("Updated Products")
              ? _c(
                  "v-btn",
                  {
                    staticClass: "btn",
                    attrs: { disabled: _vm.exportDisabled, text: "" },
                    on: { click: _vm.exportRecords }
                  },
                  [_vm._v(_vm._s(_vm.$t("Export")))]
                )
              : _vm._e(),
            _vm.$t(_vm.flagSelected) !== _vm.$t("Updated Products")
              ? _c(
                  "v-btn",
                  {
                    staticClass: "btn ml-2",
                    attrs: { disabled: _vm.deleteBtnDisabled, text: "" },
                    on: { click: _vm.deleteUpdateRecords }
                  },
                  [_vm._v(_vm._s(_vm.$t("Delete")))]
                )
              : _vm._e()
          ],
          1
        ),
        _c("div", { staticClass: "pageInfo" }, [
          _vm._v(_vm._s(_vm.pageInfoText))
        ]),
        _c(
          "div",
          [
            _c("v-pagination", {
              staticStyle: { float: "right" },
              attrs: {
                length: _vm.totalPages * 1,
                "total-visible": _vm.totalVisiblePages,
                color: "#2f3b4c"
              },
              on: { input: _vm.paging },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          ],
          1
        )
      ]),
      _c("a", { ref: "link", style: { display: "none" } }),
      _c(
        "v-dialog",
        {
          attrs: { width: "600" },
          model: {
            value: _vm.editProcessedData,
            callback: function($$v) {
              _vm.editProcessedData = $$v
            },
            expression: "editProcessedData"
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "40px 50px",
                "background-color": "#fff",
                position: "relative"
              }
            },
            [
              _c("h2", { staticClass: "page-title-bar mb-5" }, [
                _c("i", { staticClass: "ico ico-product" }),
                _vm._v(_vm._s(_vm.$t("Edit Scheduled Product")) + " ")
              ]),
              _c(
                "div",
                { staticClass: "product_detail" },
                [
                  _c("v-select", {
                    staticClass: "form-select mb-4",
                    attrs: {
                      label: _vm.$t("Timezone"),
                      placeholder: _vm.$t("Select Time Zone"),
                      items: _vm.timezoneList,
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      "item-text": _vm.getFieldText,
                      "item-value": "name"
                    },
                    on: {
                      "click:clear": _vm.clearTimeZone,
                      click: _vm.clearTimeZone
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "prepend-item",
                        fn: function() {
                          return [
                            _c("v-text-field", {
                              ref: "searchTerm",
                              staticClass: "form-input search-v-select",
                              attrs: {
                                solo: "",
                                outlined: "",
                                "hide-details": "",
                                dense: "",
                                placeholder: "Search Timezone"
                              },
                              on: { input: _vm.searchTimezone },
                              model: {
                                value: _vm.searchTerm,
                                callback: function($$v) {
                                  _vm.searchTerm = $$v
                                },
                                expression: "searchTerm"
                              }
                            }),
                            _c("v-divider")
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.timezone,
                      callback: function($$v) {
                        _vm.timezone = $$v
                      },
                      expression: "timezone"
                    }
                  }),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        "offset-y": "",
                        "min-width": "250px"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  _vm._b(
                                    {
                                      ref: "calendarstart",
                                      staticClass:
                                        "form-select mb-4 col mandatory",
                                      attrs: {
                                        label: "" + _vm.$t("Schedule Time *"),
                                        placeholder:
                                          "" + _vm.$t("Select Schedule Time"),
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "",
                                        readonly: "",
                                        clearable: "",
                                        "prepend-icon": "",
                                        "append-icon": "mdi-calendar-month"
                                      },
                                      on: {
                                        "click:clear": function($event) {
                                          _vm.scheduleTime = null
                                        },
                                        click: _vm.setCurrentDate,
                                        "click:append": function($event) {
                                          _vm.$refs.calendarstart.$el
                                            .querySelector("input")
                                            .click()
                                        }
                                      },
                                      model: {
                                        value: _vm.scheduleTime,
                                        callback: function($$v) {
                                          _vm.scheduleTime = $$v
                                        },
                                        expression: "scheduleTime"
                                      }
                                    },
                                    "v-text-field",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.schedule.showStartDatePicker,
                        callback: function($$v) {
                          _vm.$set(_vm.schedule, "showStartDatePicker", $$v)
                        },
                        expression: "schedule.showStartDatePicker"
                      }
                    },
                    [
                      _c("date-picker", {
                        attrs: {
                          mode: "dateTime",
                          "min-date": new Date(),
                          "minute-increment": 30,
                          "is-required": true,
                          is24hr: "",
                          "show-current": false
                        },
                        model: {
                          value: _vm.startTime,
                          callback: function($$v) {
                            _vm.startTime = $$v
                          },
                          expression: "startTime"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticStyle: { "margin-top": "-12px" } },
                        [
                          _c("p", { staticClass: "label-txt mb-2" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("Browse File ( Extension defined in")
                                ) +
                                " "
                            ),
                            _c("b", [
                              _vm._v(" System Config > Product File Config")
                            ]),
                            _vm._v(" ) "),
                            _c("span", { staticClass: "redbold" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _c("v-file-input", {
                            ref: "uploadFile2",
                            staticClass: "form-file",
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              solo: "",
                              flat: "",
                              placeholder: "" + _vm.$t("Select File"),
                              "prepend-icon": "",
                              "append-icon": "mdi-file-upload",
                              clearable: false
                            },
                            on: {
                              change: function($event) {
                                return _vm.appendFilesLater()
                              },
                              "click:append": function($event) {
                                _vm.$refs.uploadFile1.$el
                                  .querySelector("input")
                                  .click()
                              }
                            },
                            model: {
                              value: _vm.filesLater,
                              callback: function($$v) {
                                _vm.filesLater = $$v
                              },
                              expression: "filesLater"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c("v-col", [
                        _c("p", { staticClass: "label-txt" }, [
                          _vm._v(" " + _vm._s(_vm.$t("Selected Files")) + " "),
                          _c("span", { staticClass: "redbold" }, [
                            _vm._v(" * ")
                          ])
                        ]),
                        _c(
                          "ul",
                          { staticClass: "selectedFile-list mt-2" },
                          [
                            _vm.filesToUploadLater.length > 0
                              ? _vm._l(_vm.filesToUploadLater, function(
                                  file,
                                  i
                                ) {
                                  return _c(
                                    "li",
                                    { key: file.name },
                                    [
                                      i === _vm.filesToUploadLater.length - 1
                                        ? _c("p", [
                                            _vm._v(
                                              " " + _vm._s(file.name) + " "
                                            )
                                          ])
                                        : _vm._e(),
                                      i === _vm.filesToUploadLater.length - 1
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: { text: "", icon: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeFileLater(
                                                    file.name
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  width: "20",
                                                  height: "20",
                                                  src: require("@/assets/img/ico-delete2.png")
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                })
                              : _vm._e(),
                            _vm.filesToUploadLater.length === 0
                              ? [
                                  _c("li", [
                                    _c("p", [_vm._v("No Files selected")])
                                  ])
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: { click: _vm.handleSaveClick }
                    },
                    [_vm._v(_vm._s(_vm.$t("Upload")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          _vm.editProcessedData = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }